import Pusher from 'pusher-js';

import { notifyApiError } from 'components/layout/Toasts';

import { AuthSockets } from './connections';

const authorizer = (channel) => ({
  authorize: async (socketId, callback) => {
    try {
      const response = await AuthSockets.authorizeWebsocketConnection(socketId, channel.name);
      callback(response.status !== 200, response.data);
    } catch (err) {
      notifyApiError(err);
      callback(!!err);
    }
  }
});

const defaultConfig = {
  cluster: 'eu',
  authorizer: authorizer
};

export const SocketClient = (config) => {
  if (process.env.REACT_APP_PUSHER_KEY) {
    console.warn('process.env.REACT_APP_PUSHER_KEY', process.env.REACT_APP_PUSHER_KEY);
    return new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      ...defaultConfig,
      ...config
    });
  } else {
    console.warn('Pusher key error! You must pass your app key when you instantiate Pusher.');
    return false;
  }
};
